// Generated by scripts/build-ui-icons.mjs.
import { createAppIcon } from "./base";
import { LayoutIcon as LayoutGlyph } from "@phosphor-icons/react/dist/ssr/Layout";
import { LightbulbIcon as LightbulbGlyph } from "@phosphor-icons/react/dist/ssr/Lightbulb";
import { LightningIcon as LightningGlyph } from "@phosphor-icons/react/dist/ssr/Lightning";
import { LinkIcon as LinkGlyph } from "@phosphor-icons/react/dist/ssr/Link";
import { LinkSimpleIcon as LinkSimpleGlyph } from "@phosphor-icons/react/dist/ssr/LinkSimple";
import { LinkedinLogoIcon as LinkedinLogoGlyph } from "@phosphor-icons/react/dist/ssr/LinkedinLogo";
import { ListIcon as ListGlyph } from "@phosphor-icons/react/dist/ssr/List";
import { ListBulletsIcon as ListBulletsGlyph } from "@phosphor-icons/react/dist/ssr/ListBullets";
import { ListChecksIcon as ListChecksGlyph } from "@phosphor-icons/react/dist/ssr/ListChecks";
import { LockKeyIcon as LockKeyGlyph } from "@phosphor-icons/react/dist/ssr/LockKey";
import { LockSimpleIcon as LockSimpleGlyph } from "@phosphor-icons/react/dist/ssr/LockSimple";
import { MagicWandIcon as MagicWandGlyph } from "@phosphor-icons/react/dist/ssr/MagicWand";
import { MagnetIcon as MagnetGlyph } from "@phosphor-icons/react/dist/ssr/Magnet";
import { MagnifyingGlassIcon as MagnifyingGlassGlyph } from "@phosphor-icons/react/dist/ssr/MagnifyingGlass";
import { MagnifyingGlassMinusIcon as MagnifyingGlassMinusGlyph } from "@phosphor-icons/react/dist/ssr/MagnifyingGlassMinus";
import { MagnifyingGlassPlusIcon as MagnifyingGlassPlusGlyph } from "@phosphor-icons/react/dist/ssr/MagnifyingGlassPlus";
import { MapPinIcon as MapPinGlyph } from "@phosphor-icons/react/dist/ssr/MapPin";
import { MapPinAreaIcon as MapPinAreaGlyph } from "@phosphor-icons/react/dist/ssr/MapPinArea";
import { MapTrifoldIcon as MapTrifoldGlyph } from "@phosphor-icons/react/dist/ssr/MapTrifold";
import { MedalIcon as MedalGlyph } from "@phosphor-icons/react/dist/ssr/Medal";
import { MegaphoneIcon as MegaphoneGlyph } from "@phosphor-icons/react/dist/ssr/Megaphone";
import { MicrophoneIcon as MicrophoneGlyph } from "@phosphor-icons/react/dist/ssr/Microphone";
import { MinusIcon as MinusGlyph } from "@phosphor-icons/react/dist/ssr/Minus";
import { MoneyIcon as MoneyGlyph } from "@phosphor-icons/react/dist/ssr/Money";
import { MonitorIcon as MonitorGlyph } from "@phosphor-icons/react/dist/ssr/Monitor";
import { MoonIcon as MoonGlyph } from "@phosphor-icons/react/dist/ssr/Moon";
import { MusicNoteIcon as MusicNoteGlyph } from "@phosphor-icons/react/dist/ssr/MusicNote";
import { NewspaperIcon as NewspaperGlyph } from "@phosphor-icons/react/dist/ssr/Newspaper";
import { NoteIcon as NoteGlyph } from "@phosphor-icons/react/dist/ssr/Note";
import { PackageIcon as PackageGlyph } from "@phosphor-icons/react/dist/ssr/Package";
import { PaletteIcon as PaletteGlyph } from "@phosphor-icons/react/dist/ssr/Palette";
import { PaperPlaneTiltIcon as PaperPlaneTiltGlyph } from "@phosphor-icons/react/dist/ssr/PaperPlaneTilt";
import { PaperclipIcon as PaperclipGlyph } from "@phosphor-icons/react/dist/ssr/Paperclip";
import { PauseIcon as PauseGlyph } from "@phosphor-icons/react/dist/ssr/Pause";
import { PauseCircleIcon as PauseCircleGlyph } from "@phosphor-icons/react/dist/ssr/PauseCircle";

export const Layout = /* @__PURE__ */ createAppIcon(LayoutGlyph, "Layout");
export const Lightbulb = /* @__PURE__ */ createAppIcon(
  LightbulbGlyph,
  "Lightbulb",
);
export const Lightning = /* @__PURE__ */ createAppIcon(
  LightningGlyph,
  "Lightning",
);
export const Link = /* @__PURE__ */ createAppIcon(LinkGlyph, "Link");
export const LinkSimple = /* @__PURE__ */ createAppIcon(
  LinkSimpleGlyph,
  "LinkSimple",
);
export const LinkedinLogo = /* @__PURE__ */ createAppIcon(
  LinkedinLogoGlyph,
  "LinkedinLogo",
);
export const List = /* @__PURE__ */ createAppIcon(ListGlyph, "List");
export const ListBullets = /* @__PURE__ */ createAppIcon(
  ListBulletsGlyph,
  "ListBullets",
);
export const ListChecks = /* @__PURE__ */ createAppIcon(
  ListChecksGlyph,
  "ListChecks",
);
export const LockKey = /* @__PURE__ */ createAppIcon(LockKeyGlyph, "LockKey");
export const LockSimple = /* @__PURE__ */ createAppIcon(
  LockSimpleGlyph,
  "LockSimple",
);
export const MagicWand = /* @__PURE__ */ createAppIcon(
  MagicWandGlyph,
  "MagicWand",
);
export const Magnet = /* @__PURE__ */ createAppIcon(MagnetGlyph, "Magnet");
export const MagnifyingGlass = /* @__PURE__ */ createAppIcon(
  MagnifyingGlassGlyph,
  "MagnifyingGlass",
);
export const MagnifyingGlassMinus = /* @__PURE__ */ createAppIcon(
  MagnifyingGlassMinusGlyph,
  "MagnifyingGlassMinus",
);
export const MagnifyingGlassPlus = /* @__PURE__ */ createAppIcon(
  MagnifyingGlassPlusGlyph,
  "MagnifyingGlassPlus",
);
export const MapPin = /* @__PURE__ */ createAppIcon(MapPinGlyph, "MapPin");
export const MapPinArea = /* @__PURE__ */ createAppIcon(
  MapPinAreaGlyph,
  "MapPinArea",
);
export const MapTrifold = /* @__PURE__ */ createAppIcon(
  MapTrifoldGlyph,
  "MapTrifold",
);
export const Medal = /* @__PURE__ */ createAppIcon(MedalGlyph, "Medal");
export const Megaphone = /* @__PURE__ */ createAppIcon(
  MegaphoneGlyph,
  "Megaphone",
);
export const Microphone = /* @__PURE__ */ createAppIcon(
  MicrophoneGlyph,
  "Microphone",
);
export const Minus = /* @__PURE__ */ createAppIcon(MinusGlyph, "Minus");
export const Money = /* @__PURE__ */ createAppIcon(MoneyGlyph, "Money");
export const Monitor = /* @__PURE__ */ createAppIcon(MonitorGlyph, "Monitor");
export const Moon = /* @__PURE__ */ createAppIcon(MoonGlyph, "Moon");
export const MusicNote = /* @__PURE__ */ createAppIcon(
  MusicNoteGlyph,
  "MusicNote",
);
export const Newspaper = /* @__PURE__ */ createAppIcon(
  NewspaperGlyph,
  "Newspaper",
);
export const Note = /* @__PURE__ */ createAppIcon(NoteGlyph, "Note");
export const Package = /* @__PURE__ */ createAppIcon(PackageGlyph, "Package");
export const Palette = /* @__PURE__ */ createAppIcon(PaletteGlyph, "Palette");
export const PaperPlaneTilt = /* @__PURE__ */ createAppIcon(
  PaperPlaneTiltGlyph,
  "PaperPlaneTilt",
);
export const Paperclip = /* @__PURE__ */ createAppIcon(
  PaperclipGlyph,
  "Paperclip",
);
export const Pause = /* @__PURE__ */ createAppIcon(PauseGlyph, "Pause");
export const PauseCircle = /* @__PURE__ */ createAppIcon(
  PauseCircleGlyph,
  "PauseCircle",
);
